import {
  CLASS_NAMES,
  SCALE,
} from "../../utils/constants";
import Explosion from "./Explosion";
import GameObject from "./GameObject";
import Phaser from "phaser";
import UI from "../UI";

export default class Debris extends GameObject {
  constructor(id, level) {
    super({
      id,
      isRigid: true,
      isBreakable: true,
      isFlat: true,
      isPickable: false,
      isCrushable: false,
      level,
    });
    this.strength = 9; // one less than explosion
  }
  overrunBy(el) {
    if (el && el.isClass(Explosion)) {
      const layer = this.level.scene.children.getByName("layer_1");
      const { tilemap: map } = layer;

      map.putTileAt(
        -1, // leave space really empty and display tile from layer_0 (underlayer)
        this.position.x,
        this.position.y,
        false,
        "layer_1"
      );
    } else {
      const layer = this.level.scene.children.getByName("layer_1");
      const { tilemap: map } = layer;

      map.putTileAt(
        -1, // leave space really empty and display tile from layer_0 (underlayer)
        this.position.x,
        this.position.y,
        false,
        "layer_1"
      );
      // destroyed by earthquake
      this.break_effect = this.level.scene.add
        .sprite(48, 16)
        .setOrigin(0, 0.25);
      this.break_effect.setScale(SCALE);
      this.break_effect.depth = 4;
      this.break_effect.x = UI.tileToScreen(this.position.x);
      this.break_effect.y = UI.tileToScreen(this.position.y);
      this.break_effect.play("ground_disolves");
      this.break_effect.setFlipY(true);
      this.break_effect.on(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
        this.break_effect.destroy();
      });
    }
  }
}

Debris.className = CLASS_NAMES.DEBRIS
